import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { BASEAPIURL, UPLOADNODEURL, showfulldatetime } from '../../../../config';

function ProfileSetting({ forpage }) {
    const [deleteAccount, setDeleteAccount] = useState({
        form: false,
        capcha1: Math.floor(Math.random() * 9) + 1,
        capcha2: Math.floor(Math.random() * 9) + 1,
    });
    const [defaultProfilePicture] = useState('placeholders/userProfileImg.png');
    const [Profile, setProfile] = useState({
        name: '',
        email: '',
        mobile: '',
        lastLogin: '',
        photo: defaultProfilePicture,
    });

    useEffect(() => {
        const FetchProfile = async () => {
            try {
                const res = await fetch(`${BASEAPIURL}/student/myprofile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                    },
                    body: JSON.stringify({
                        loggedToken: localStorage.getItem('loggedToken'),
                        usertype: localStorage.getItem('usertype'),
                    }),
                });
                const resJson = await res.json();
                if (res.status === 200) {
                    if (resJson.userdata && resJson.userdata !== null) {
                        setProfile(resJson.userdata);
                    }
                } else {
                    console.log(resJson.message);
                }
            } catch (err) {
                console.log(err);
            }
        };
        FetchProfile();
    }, []);

    function GetShowData(forData, Index, defaultValue) {
        let returnValue = defaultValue;
        if (forData && forData[Index] && forData[Index] !== null && forData[Index] !== '') {
            returnValue = forData[Index];
        }
        return returnValue;
    }

    return (
        <>
            {deleteAccount.form ? (
                <div className="pb-3" forpage={forpage}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ry_instr_shadow p-3" style={{ border: '1px solid #f5f5f5' }}>
                                <h6 className="std_header_on_page">Delete Account</h6>
                                <div style={{ clear: 'both' }}></div>
                                <hr />
                                <p className='text-dark'>
                                Please note that once your account is deleted, you will no longer have access to your courses.
                                <br /> <br />
                                You can create a new account later using the same details, but your existing courses/ Data will not be restored.
                                <br /> <br />
                                To proceed with account deletion, please enter your password below.
                                    <br />
                                    <br />
                                </p>
                                <div className='form-group'>
                                    <label>Current Password</label>
                                    <input type="password" className='form-control' placehodler="Enter Password" />
                                </div>
                                <div className='form-group'>
                                    <label>Verification (Enter {deleteAccount.capcha1} + {deleteAccount.capcha2}) below</label>
                                    <input type="number" className='form-control' placehodler="Enter Password" />
                                </div>
                                
                                <div className="text-center mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary p-1 pl-4 pr-4 mt-4"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            alert("Under Development");
                                        }}
                                    >
                                        Confirm Delete
                                    </button>
                                    <a
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setDeleteAccount({ ...deleteAccount, form: false });
                                        }}
                                        className="btn btn-danger ml-2 p-1 pl-4 pr-4 mt-4"
                                    >
                                        Cancel
                                    </a>
                                    <small className="text-info d-none">
                                        You are logged in on
                                        {showfulldatetime(Number(GetShowData(Profile, 'lastLogin', 0)))}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="pb-3" forpage={forpage}>
                    <div className="row">
                        <div className="col-md-7">
                            <div className="ry_instr_shadow p-3">
                                <h6 className="std_header_on_page">
                                    {GetShowData(Profile, 'name', 'NA')}
                                </h6>
                                <div style={{ clear: 'both' }}></div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-4">Gender</div>
                                    <div className="col-md-8">
                                        {GetShowData(Profile, 'gender', 'NA')}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">City</div>
                                    <div className="col-md-8">{GetShowData(Profile, 'city', 'NA')}</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">Address</div>
                                    <div className="col-md-8">
                                        {GetShowData(Profile, 'address', 'NA')}
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">Phone Number</div>
                                    <div className="col-md-8">
                                        <a href={`tel:${GetShowData(Profile, 'mobile', '')}`}>
                                            {GetShowData(Profile, 'mobile', 'NA')}
                                        </a>
                                        {GetShowData(Profile, 'mobileVerify', '0') && GetShowData(Profile, 'mobileVerify', '0') !== '0' ? (
                                            <>&nbsp;<i title="Verified Mobile" className='fa text-success fa-check-circle '/></>
                                        ): (
                                            <Link to="/user/page/updateprofilesetting" className='text-danger'>
                                                <small>
                                                    &nbsp;<i className='fa text-danger fa-check-circle '/>Verify
                                                </small>
                                            </Link>
                                        )}
                                        
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">Email</div>
                                    <div className="col-md-8">
                                        <a href={`mailto:${GetShowData(Profile, 'email', '')}`}>
                                            {GetShowData(Profile, 'email', 'NA')}
                                        </a>
                                        {GetShowData(Profile, 'emailVerify', '0') && GetShowData(Profile, 'emailVerify', '0') !== '0' ? (
                                            <>&nbsp;<i title="Verified Email" className='fa text-success fa-check-circle '/></>
                                        ): (
                                            <Link to="/user/page/updateprofilesetting" className='text-danger'>
                                                <small>
                                                    &nbsp;<i className='fa text-danger fa-check-circle '/>Verify
                                                </small>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                                <div className="text-center mt-2">
                                    <Link
                                        to="/user/page/updateprofilesetting"
                                        className="btn btn-secondary p-1 pl-4 pr-4 mt-4"
                                    >
                                        Edit Profile
                                    </Link>
                                    <Link
                                        to="/user/page/changePassword"
                                        className="btn btn-danger ml-2 p-1 pl-4 pr-4 mt-4"
                                    >
                                        Change Password
                                    </Link>
                                    <small className="text-info d-none">
                                        You are logged in on
                                        {showfulldatetime(Number(GetShowData(Profile, 'lastLogin', 0)))}
                                    </small>
                                </div>
                                <div className="text-left mt-4">
                                    <h6 className="std_header_on_page mt-4">Email notifications</h6>
                                    <Link to="/user/page/EmailNotificationSetting" className="mt-2">
                                        Turn promotional email notifications from Acumen Glow ON or OFF
                                    </Link>
                                </div>
                                
                                <div className="text-left mt-4">
                                    <h6 className="std_header_on_page mt-4">Delete account</h6>
                                    <Link
                                        to="/"
                                        className="mt-2"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setDeleteAccount({ ...deleteAccount, form: true });
                                        }}
                                    >
                                        Click here to delete your account.
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="text-center ry_instr_shadow p-3">
                                <Link to="/user/page/updateprofilesetting">
                                    <img
                                        src={`${UPLOADNODEURL}${GetShowData(
                                            Profile,
                                            'photo',
                                            defaultProfilePicture
                                        )}`}
                                        alt={GetShowData(Profile, 'name', 'NA')}
                                        className="p-3"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ProfileSetting;
